module.exports = __webpack_public_path__ + "assets/img/yb-a.0f3e0d7e.png";